"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var projectChecks_exports = {};
__export(projectChecks_exports, {
  create: () => create,
  editQualificationAssociations: () => editQualificationAssociations,
  editSettings: () => editSettings,
  grantAccess: () => grantAccess,
  member: () => member,
  remove: () => remove,
  view: () => view,
  viewInvitations: () => viewInvitations,
  viewMembers: () => viewMembers,
  viewSettings: () => viewSettings,
  viewTeams: () => viewTeams
});
module.exports = __toCommonJS(projectChecks_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_check = require("../check/index.js");
function member(project) {
  return import_check.check.named(
    `Member of project ${project.name} (${project.id})`,
    import_check.check.projectMember(project.id, project.workspaceId, project.teamIds)
  );
}
function view(project) {
  return import_check.check.named(`View project ${project.name} (${project.id})`, canReadProjectInternal(project));
}
function viewTeams(project) {
  return import_check.check.named(`View teams for project ${project.name} (${project.id})`, canReadProjectInternal(project));
}
function viewSettings(project) {
  return import_check.check.named(
    `View settings for project ${project.name} (${project.id})`,
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function viewMembers(project) {
  return import_check.check.named(
    `View members for project ${project.name} (${project.id})`,
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function viewInvitations(project) {
  return import_check.check.named(
    `View invitations to project ${project.name} (${project.id})`,
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function create(workspace) {
  return import_check.check.named(`Can create projects in workspace ${workspace.name} (${workspace.id})`, import_check.check.globalAdmin);
}
function editSettings(project) {
  return import_check.check.named(
    `Edit settings for project ${project.name} (${project.id})`,
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function grantAccess(project) {
  return import_check.check.named(
    `Grant access to project ${project.name} (${project.id})`,
    import_check.check.projectCoordinator(project.id, project.workspaceId, null)
  );
}
function editQualificationAssociations(project, qualificationId) {
  return import_check.check.named(
    `Add/remove qualification ${qualificationId} to/from project ${project.name} (${project.id})`,
    import_check.check.and(
      import_check.check.projectCoordinator(project.id, project.workspaceId, null),
      import_check.check.hasQualification((0, import_types.qualificationCoordinatorRole)(qualificationId))
    )
  );
}
function remove(project) {
  return import_check.check.named(`Can delete project ${project.id}`, import_check.check.globalAdmin);
}
function canReadProjectInternal(project) {
  switch (project.projectVisibility) {
    case "Private":
      return import_check.check.projectMember(project.id, project.workspaceId, project.teamIds);
    case "Workspace":
      return import_check.check.workspaceActive(project.workspaceId);
    default:
      return (0, import_util.checkExhausted)(project.projectVisibility);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  create,
  editQualificationAssociations,
  editSettings,
  grantAccess,
  member,
  remove,
  view,
  viewInvitations,
  viewMembers,
  viewSettings,
  viewTeams
});
//# sourceMappingURL=projectChecks.js.map
